
import React, {useEffect, useState} from 'react';
import { Dialog, DialogTitle, DialogContent, Grid, Chip, TextField } from '@mui/material';
import AgyleButton from '../../ui/buttons/agyleButton';
import { AutocompleteDictionary } from '../../../controls/agyle/autocomplete';

const ShareSmartViewDialog = ({
    open,
    onClose,
    viewToShare,
    onShare
}) => {

    const [selectedUsers, setSelectedUsers] = useState([]);

    const getDictionaryURL = (filter) => {
        return `/users?$filter=username regex '${filter}.*' or firstname regex '${filter}.*' or familyname regex '${filter}.*' &$page=1&$pageSize=10&activeOnly=true`;
    };

    const renderOptionLine = (createParts, option, classes, inp) => {
        return <div {...inp}>{option.fullName + " (" + option.userName + ")"}</div>;
    };

    const handleShare = () => {
        onShare(selectedUsers);
        setSelectedUsers([]);
        onClose();
    };

    useEffect(() => {
        setSelectedUsers([]);
    }, [open]);
    return (
        <Dialog maxWidth={"xs"} open={open} onClose={onClose}
            onBackdropClick={onClose}
        >
            <DialogTitle>
                Share Smart View "{viewToShare != null ? viewToShare.name : ""}"
            </DialogTitle>
            <DialogContent>
                <Grid container>
                    <Grid item xs={4}>
                        Share with:
                    </Grid>
                    <Grid item xs={8}>
                        <AutocompleteDictionary
                            value={selectedUsers}
                            noRegex
                            dictionaryURL={getDictionaryURL}
                            dictType={"API"}
                            multiple
                            getOptionLabel={option => {
                                return option.fullName || "";
                            }}
                            renderLocalOption={renderOptionLine}
                            isOptionEqualToValue={(option, value) => option?.userName === value?.userName}
                            size={"small"}
                            onChange={(newValue) => {
                                setSelectedUsers(newValue);
                            }}
                            renderTags={(tagValue, getTagProps) =>
                                tagValue.map((option, index) => (
                                    <Chip
                                        key={index}
                                        label={option.fullName + " (" + option.userName + ")"}
                                        {...getTagProps({ index })}
                                    />
                                ))
                            }
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    label="Select users"
                                    placeholder="Users"
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <AgyleButton
                            style={{ marginTop: 20 }}
                            color="primary"
                            onClick={handleShare}>
                            Share
                        </AgyleButton>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default ShareSmartViewDialog;
